import { ApiErrorResponseModel } from '@lib/interfaces';
import { AswContextState } from '@lib/store';
import { GetOrderResponse, UpdateServicesResponse } from 'src/sdk-servicing';
import { CountryI18nBy2LetterCode } from '../master/country_i18n_by2lettercode';
import { CountryI18nPosCountry } from '../master/country_i18n_pos_country';
import { MChargeableService } from '../master/m_chargeable_service';
import { MChargeableServiceSsr } from '../master/m_chargeable_service_ssr';
import { MListData } from '../master/m_listdata';
import { MPaymentError } from '../master/m_payment_error';
import { MPaymentInformation } from '../master/m_payment_information';
import { MOfficeByOffceCode } from '../master/office_by offce_code';
import { PosCountryAll } from '../master/pos_county_all';

export interface SetupCompleteData {
  sessionId: string;
  modules: Array<ModuleCardinal>;
}
export interface ModuleCardinal {
  module: string;
  loaded: boolean;
}
export interface ApiResponse {
  model?: UpdateServicesResponse;
  error?: ApiErrorResponseModel;
}
export interface BrandImage {
  src?: string;
  alt?: string;
}

export interface UpdateServicesParam {
  blackBox: string;
}

export interface TravelerUpdateService {
  travelerId?: string;
  email?: string;
  phone?: PhoneUpdateService;
}

export interface PassengerSMSInformation {
  countryPhoneExtension?: string;
  number?: string;
}

export interface PhoneUpdateService {
  countryPhoneExtension?: string;
  number?: number;
}

export interface CardinalResultInfo {
  // エラーコード
  errorNumber?: number;
  // エラー詳細
  errorDescription?: string;
  // JWTトークン
  jwtToken?: string;
  // キャンセル判定
  challengeCancel?: string;
}

export interface CardinalResponse {
  Validated: boolean;
  ErrorNumber: number;
  ErrorDescription: string;
  ActionCode: string;
  Payment: {
    ExtendedData: {
      ChallengeCancel: string;
    };
  };
}
export interface MasterDataS02P020 {
  paymentInformation?: Array<MPaymentInformation>;
  paymentErrors?: Array<MPaymentError>;
  countryI18nBy2LetterCodes?: Array<CountryI18nBy2LetterCode>;
  posCountryAll?: Array<PosCountryAll>;
  listData?: Array<MListData>;
  officeByOffceCodeInfo?: MOfficeByOffceCode;
  chargeableService?: Array<MChargeableService>;
  chargeableServiceSsr?: Array<MChargeableServiceSsr>;
  countryI18nPosCountries?: Array<CountryI18nPosCountry>;
}

// type for dynamic message params
export interface ServiceRequestPaymentInputParams {
  aswContext?: AswContextState;
  getOrderReply?: GetOrderResponse;
  pageContext?: {
    currentPaymentMethod?: string;
  };
}

export const INITIAL_MASTER_DATA: MasterDataS02P020 = {
  paymentInformation: [],
  paymentErrors: [],
  countryI18nBy2LetterCodes: [],
  posCountryAll: [],
  listData: [],
  officeByOffceCodeInfo: undefined,
  chargeableService: [],
  chargeableServiceSsr: [],
  countryI18nPosCountries: [],
};
